'use es6';

import getSelectedExternalOptions from 'FormsUI/selectors/formDefinition/getSelectedExternalOptions';
import { LIFECYCLESTAGE } from 'FormsUI/constants/SelectedExternalOptions';
const getCustomLifecycleStage = state => {
  const selectedExternalOptions = getSelectedExternalOptions(state);
  const customLifecycleState = selectedExternalOptions.find(({
    propertyName
  }) => propertyName === LIFECYCLESTAGE);
  return customLifecycleState ? customLifecycleState.id : null;
};
export default getCustomLifecycleStage;